"use strict";

import * as THREE from "three";

import ShootMaterial from "./ShootMaterial";
import ShootGeometry from "./ShootGeometry";

import { Animator, Easing } from "./Animation"

class Bloom extends THREE.Group {
    bounds: number;
    materials: ShootMaterial[] = [];

    constructor(preset: BloomPreset) {
        super();

        preset = {
            bounds: 1,
            ...preset
        };

        // Store for radius checks.
        this.bounds = preset.bounds;

        // Collider
        let colliderGeometry = new THREE.SphereBufferGeometry(preset.bounds * 1.5, 12, 6);
        {
            let colliderMaterial = new THREE.MeshBasicMaterial();
            colliderMaterial.visible = false;
            let colliderMesh = new THREE.Mesh(colliderGeometry, colliderMaterial)
            colliderMesh.layers.enable(1);
            this.add(colliderMesh);
        }

        // Bounds wireframe
        // {
        //     let wireframeGeometry = new THREE.WireframeGeometry(colliderGeometry);
        //     const wireframe = new THREE.LineSegments(wireframeGeometry);
        //     wireframe.material.color = new THREE.Color(0, 1, 0);
        //     wireframe.material.depthTest = false;
        //     wireframe.material.opacity = 0.25;
        //     wireframe.material.transparent = true;
        //     wireframe.position.set(0, .5, 0);
        //     this.add(wireframe);
        // }

        // Process shoots.
        preset.shootPresets.forEach(shootPreset => {

            // console.log("Processing preset: " + shootPreset.id);

            // Fill in preset defaults.
            shootPreset = {
                transformInstance(i) {
                    let progress = (i / this.shootCount);

                    const rotation = new THREE.Euler(0, 0, 0);
                    const quaternion = new THREE.Quaternion();
                    const matrix = new THREE.Matrix4();

                    rotation.y = progress * 2 * Math.PI;
                    if (i % 2 == 0) rotation.z = Math.PI * -.05;

                    quaternion.setFromEuler(rotation);

                    matrix.compose(
                        new THREE.Vector3(),
                        quaternion,
                        new THREE.Vector3(1, 1, 1));

                    return matrix;
                },
                ...shootPreset
            }

            let shootMaterial = new ShootMaterial(shootPreset.materialPreset);

            // Fetch or generate geometry.
            let shootGeometry;
            if (shootPreset.id != null && ShootGeometry.Cache.has(shootPreset.id)) {
                shootGeometry = ShootGeometry.Cache.get(shootPreset.id);
            } else {
                shootGeometry = new ShootGeometry(shootPreset);
                ShootGeometry.Cache.set(shootPreset.id, shootGeometry);
            }

            // Create and transform instanced mesh.
            let shootMesh = new THREE.InstancedMesh(shootGeometry, shootMaterial, shootPreset.shootCount);
            for (let i = 0; i < shootPreset.shootCount; i++) {
                let matrix = shootPreset.transformInstance(i);
                shootMesh.setMatrixAt(i, matrix);
                shootMesh.setColorAt(i, new THREE.Color(
                    THREE.MathUtils.randFloat(.95, 1.05),
                    THREE.MathUtils.randFloat(.95, 1.05),
                    THREE.MathUtils.randFloat(.95, 1.05)
                ));
            }

            shootMesh.geometry.boundingSphere = new THREE.Sphere(new THREE.Vector3(), this.bounds);
            shootMesh.instanceMatrix.needsUpdate = true;
            shootMesh.frustumCulled = true;

            // Store mesh and material.
            this.add(shootMesh);
            this.materials.push(shootMaterial);
        });
    }

    reset() {
        this.materials.forEach(material => {
            material.uniforms.progress.value = 0;
        });
    }

    grow(duration: number, callback?: Function) {
        Animator.animate({
            duration: duration,
            updateCallback: function (t) {
                this.materials.forEach(material => {
                    material.uniforms.progress.value = Easing.EaseOutCubic(t);
                    this.rotateY(Easing.EaseOutCubic(1 - t) * .01);
                });
            }.bind(this),
            completeCallback: function () {
                callback?.();
            }
        })
    }

    update(time) {
        this.materials.forEach(material => {
            material.uniforms.time.value = time;
        });
    }
}

export default Bloom;